import {createStylesContext} from '@chakra-ui/system';

const ComponentName = `CustomSelect` as const;
export const [StylesProvider, useStyles] = createStylesContext(ComponentName);
